import styles from "../Daetong.module.css"

export default function Loading({Constellation}){
    return(
        <div className="loadingPage">
            <div className={`loadingPage_inner ${styles.loadingPage_inner_daetong}`}>
                {/* <Constellation></Constellation> */}
                <div className="loadingContent">
                    <div className="circleBox">
                        <div className="circleBox_inner"></div>
                        <h4>
                            <img src={process.env.PUBLIC_URL + '/image/daetong_logo.png'} alt='별별운세' />
                        </h4>
                    </div>
                    <span>잠시만 기다려주세요...</span>
                    <h5>
                        입력하신 정보를 바탕으로<br/>
                        당신의 운의 흐름을 정성껏 풀이하고 있어요!
                    </h5>
                </div>
            </div>
        </div>
    )
}
